// extracted by mini-css-extract-plugin
export default {"formWrapper":"ZQH3JmFJ","flexWrapper":"fUx95HFO","description":"r5Lqjm0x","title":"sHcQ9qJy","cell":"CvqNyXFp","field":"uhnx6vbB","buttonWrapper":"TNsCI9eo","label":"UDdY_eiP"};
    if(module.hot) {
      // 1734636551922
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  